<template>
    <div class="cases">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1>成功案例</h1>
            <p>我们为各行业客户提供专业的软件开发解决方案</p>
        </div>

        <!-- 案例分类 -->
        <div class="section case-categories">
            <el-tabs v-model="activeCategory" class="category-tabs">
                <el-tab-pane label="全部案例" name="all"></el-tab-pane>
                <el-tab-pane label="小程序开发" name="miniprogram"></el-tab-pane>
                <el-tab-pane label="网站开发" name="website"></el-tab-pane>
                <el-tab-pane label="APP开发" name="app"></el-tab-pane>
            </el-tabs>
        </div>

        <!-- 案例列表 -->
        <div class="section case-list">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="8" v-for="caseItem in filteredCases" :key="caseItem.id">
                    <el-card class="case-card" :body-style="{ padding: '0px' }">
                        <div class="case-image">
                            <img :src="caseItem.image" :alt="caseItem.title">
                            <div class="case-overlay">
                                <el-button type="primary" @click="showCaseDetail(caseItem)">查看详情</el-button>
                            </div>
                        </div>
                        <div class="case-content">
                            <h3>{{ caseItem.title }}</h3>
                            <p class="case-category">{{ caseItem.category }}</p>
                            <p class="case-description">{{ caseItem.description }}</p>
                            <div class="case-tags">
                                <el-tag v-for="tag in caseItem.tags" :key="tag" size="small">{{ tag }}</el-tag>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 案例详情对话框 -->
        <el-dialog
            v-model="dialogVisible"
            :title="selectedCase?.title"
            width="70%"
            class="case-dialog"
        >
            <div v-if="selectedCase" class="case-detail">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <img :src="selectedCase.image" :alt="selectedCase.title" class="detail-image">
                    </el-col>
                    <el-col :span="12">
                        <div class="detail-content">
                            <h3>项目概述</h3>
                            <p>{{ selectedCase.description }}</p>
                            <h3>技术特点</h3>
                            <ul>
                                <li v-for="(feature, index) in selectedCase.features" :key="index">
                                    {{ feature }}
                                </li>
                            </ul>
                            <h3>项目成果</h3>
                            <p>{{ selectedCase.results }}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import case1 from '@/assets/images/case1.jpg';
import case3 from '@/assets/images/case3.jpg';

export default {
    name: 'Cases',
    data() {
        return {
            activeCategory: 'all',
            dialogVisible: false,
            selectedCase: null,
            cases: [
                {
                    id: 1,
                    title: '某电商小程序',
                    category: '小程序开发',
                    description: '基于微信小程序平台开发的综合电商平台，支持多商户入驻',
                    image: case1,
                    tags: ['微信小程序', '电商', '多商户'],
                    features: [
                        '支持多商户入驻管理',
                        '完整的商品管理系统',
                        '订单追踪和物流管理',
                        '会员积分系统'
                    ],
                    results: '项目上线后，客户月交易额提升300%，用户活跃度显著提高。'
                },
                {
                    id: 2,
                    title: '企业管理系统',
                    category: '网站开发',
                    description: '为大型企业定制的人力资源管理系统，提高企业管理效率',
                    image: case3,
                    tags: ['企业网站', '管理系统', '人力资源'],
                    features: [
                        '员工信息管理',
                        '考勤系统集成',
                        '绩效评估模块',
                        '薪资管理系统'
                    ],
                    results: '系统上线后，企业人力资源管理效率提升50%，运营成本降低30%。'
                },
                {
                    id: 3,
                    title: '生鲜配送APP',
                    category: 'APP开发',
                    description: '面向社区的生鲜配送应用，支持iOS和Android双平台',
                    image: case1,
                    tags: ['移动应用', '生鲜配送', '社区服务'],
                    features: [
                        '实时配送追踪',
                        '智能路线规划',
                        '社区团购功能',
                        '会员积分系统'
                    ],
                    results: 'APP上线后，日订单量突破1000单，用户满意度达95%。'
                }
            ]
        }
    },
    computed: {
        filteredCases() {
            if (this.activeCategory === 'all') {
                return this.cases;
            }
            return this.cases.filter(c => c.category === this.activeCategory);
        }
    },
    methods: {
        showCaseDetail(caseItem) {
            this.selectedCase = caseItem;
            this.dialogVisible = true;
        }
    }
}
</script>

<style scoped>
.cases {
    padding: 80px 20px 40px;
}

.page-header {
    text-align: center;
    margin-bottom: 40px;
}

.page-header h1 {
    font-size: 36px;
    color: #2c3e50;
    margin-bottom: 10px;
}

.page-header p {
    font-size: 18px;
    color: #666;
}

.section {
    margin-bottom: 40px;
}

.category-tabs {
    margin-bottom: 30px;
}

.case-card {
    margin-bottom: 30px;
    transition: all 0.3s ease;
}

.case-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.case-image {
    position: relative;
    height: 650px;
    overflow: hidden;
}

.case-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.case-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.case-card:hover .case-overlay {
    opacity: 1;
}

.case-content {
    padding: 20px;
}

.case-content h3 {
    margin: 0 0 10px;
    font-size: 20px;
    color: #2c3e50;
}

.case-category {
    color: #409EFF;
    font-size: 14px;
    margin-bottom: 10px;
}

.case-description {
    color: #666;
    margin-bottom: 15px;
    line-height: 1.5;
}

.case-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.case-tags .el-tag {
    margin-right: 5px;
}

/* 案例详情对话框样式 */
.case-detail {
    padding: 20px;
}

.detail-image {
    width: 100%;
    height: 650px;
    object-fit: cover;
    border-radius: 8px;
}

.detail-content {
    padding: 20px;
}

.detail-content h3 {
    color: #2c3e50;
    margin: 20px 0 10px;
}

.detail-content p {
    color: #666;
    line-height: 1.6;
}

.detail-content ul {
    padding-left: 20px;
    color: #666;
}

.detail-content li {
    margin-bottom: 8px;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .cases {
        padding: 60px 10px 20px;
    }

    .page-header h1 {
        font-size: 28px;
    }

    .case-image {
        height: 200px;
    }

    .detail-image {
        height: 300px;
    }
}
</style>
